import PersonIcon from '@mui/icons-material/Person';
import { ButtonLink } from './ButtonLink';

import { DataGrid, GridColDef, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';
import React from 'react';
//import { Workshop } from '../types/Workshop';

import { fromDateStr, formatDate } from '../Utils';

export interface WorkshopAdminRecord {
    id: number,
    guid: string,
    workshop: string,
    location: string,
    contactEmail: string,
    member: string,
    startDate: string,
    endDate: string
    maxUsers: number,
    informationUrl: string,
    fee: string
}

export interface WorkshopAdminTableProps {
    rows: WorkshopAdminRecord[]
}

export const WorkshopAdminTable = ({rows}: WorkshopAdminTableProps) => {
    const SearchInputField = () => 
        <Box my={10}>
            <GridToolbarQuickFilter placeholder={"filter by keyword"}/>;
        </Box>

    const columns: GridColDef[] = [
        {
            field: 'workshop',
            headerName: "Workshop",
            flex: 5,
            renderCell: (params) => <Typography variant='bold'>{params.row.workshop}</Typography>
        },
        {
            field: 'location',
            headerName: "Location",
            flex: 5
        },
        {
            field: 'guid',
            headerName: "GUID",
            flex: 3
        },
        {
            field: 'date',
            headerName: "Date",
            valueGetter: (value, row) => {
                const startDateStr = row.startDate ? fromDateStr(row.startDate) : null;
                const endDateStr = row.startDate ? fromDateStr(row.endDate) : null;
                return `${startDateStr ? formatDate(startDateStr) : ''} - ${endDateStr ? formatDate(endDateStr) : ''}`;
            },
            flex: 3
        },
        {
            field: 'adminButton',
            headerName: '',
            flex: 2,
            sortable: false,
            renderCell: (params) =>
                <ButtonLink to="/WSAdministration" state={{
                    ...params.row, startDate: formatDate(fromDateStr(params.row.startDate)),
                    endDate: formatDate(fromDateStr(params.row.endDate))
                }}
                    startIcon={<PersonIcon />}>
                    {"Administrate"}
                </ButtonLink>
        }
    ]

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <DataGrid
                columns={columns}
                rows={rows}
                disableColumnMenu
                showCellVerticalBorder

                getRowClassName={(params)=>params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even':'Mui-odd'}

                slots={{toolbar: SearchInputField}}
            />
        </div>
    )
}